import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
let _ = require('lodash');
export default {
  data() {
    return {
      conditions: [],
      // 默认express操作符
      defalutexpress: [{
        value: '===',
        label: '等于'
      }, {
        value: '!==',
        label: '不等于'
      }],
      inputcompt: 'editinput|richtext|edittextarea|autonumber|numberinput|rate|belonger|contact',
      selectcompt: 'radiobutton|checklist|selectbox|selectmultibox',
      itemselectOptions: [],
      datecompt: 'dateinput|datetimerange'
    };
  },
  components: {},
  props: {
    structform: {
      type: Object,
      default: {}
    },
    List: {
      type: Array,
      default: []
    }
  },
  mounted() {
    if (this.List.length === 0) {
      console.log(this.structform);
      let options = this.getExpress(this.structform[0].compt);
      this.conditions[0] = {
        alias: this.structform[0].alias,
        compt: this.structform[0].compt,
        express: options[0],
        expressOptions: options,
        val: ''
      };
    }
  },
  methods: {
    addCondition() {
      let options = this.getExpress(this.structform[0].compt);
      this.conditions.push({
        alias: this.structform[0].alias,
        compt: this.structform[0].compt,
        express: options[0],
        expressOptions: options,
        val: ''
      });
    },
    deleteCondition(index) {
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.conditions.splice(index, 1);
        this.$forceUpdate();
      }).catch(() => {});
    },
    structSelect(val, item, index) {
      console.log(val);
      console.log(item);
      let c = this.structform.find(item => {
        return item.alias === val;
      });
      let options = this.getExpress(c.compt);
      this.conditions[index] = {
        alias: c.alias,
        compt: c.compt,
        express: options[0],
        expressOptions: options,
        val: ''
      };
      if (this.selectcompt.includes(c.compt)) this.conditions[index].selectOptions = c.field.options;
      console.log(this.conditions);
    },
    expressSelect() {},
    selectInputChange(val, index) {
      this.conditions[index].val = val;
      console.log(this.conditions);
    },
    selectChange(val, index) {
      this.conditions[index].val = Array.isArray(val) ? val : [val];
    },
    /**
     * 处理express操作符
     * @param {Object} val 字段类型
     */
    getExpress(val) {
      let currentExpress = _.cloneDeep(this.defalutexpress);
      // 是数字类型字段或日期类型
      if (val === 'numberinput' || val === 'dateinput') {
        let numberdateexpress = [{
          value: '>',
          label: '大于'
        }, {
          value: '>=',
          label: '大于等于'
        }, {
          value: '<',
          label: '小于'
        }, {
          value: '<=',
          label: '小于等于'
        }, {
          value: '><',
          label: '选择范围'
        }];
        numberdateexpress.forEach(items => {
          currentExpress.push(items);
        });
      } else {
        let nonumberdateexpress = [{
          value: 'like',
          label: '包含'
        }, {
          value: 'notLike',
          label: '不包含'
        }];
        nonumberdateexpress.forEach(items => {
          currentExpress.push(items);
        });
      }
      // 是单选，多选，联系人，部门字段
      if (val === 'radiobutton' || val === 'checklist' || val === 'contact' || val == 'department') {
        let otherexpress = [{
          value: 'match',
          label: '等于任意一个'
        }, {
          value: 'notMatch',
          label: '不等于任意一个'
        }, {
          value: 'allMatch',
          label: '同时包含'
        }];
        otherexpress.forEach(items => {
          currentExpress.push(items);
        });
      }
      return currentExpress;
    }
  }
};